import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { data, dataActive, dataNew, groupButton } from "./HandleChart/Constant";
import { handleValue } from "./HandleChart/CustomTooltip";
import Barchart from "./TypeChart/BarChart";
import LineChart from "./TypeChart/LineChart";

const Wallet = () => {
  const { t } = useTranslation();
  const [active, setActive] = useState("1");
  const [defaultData, setDefaulData] = useState(data);
  const [activeOption, setActiveOption] = useState("Total");
  const [optionChart, setOptionChart] = useState(false);
  const [resultAfterSplit, setResultAfterSplit] = useState([]);

  const handleClick = (event) => {
    switch (event.target.id) {
      case "1":
        setActive(event.target.id);
        setOptionChart(false);
        break;
      case "2":
        setActive(event.target.id);
        setResultAfterSplit(handleConvertDataByDays(7));
        break;
      case "3":
        setActive(event.target.id);
        setResultAfterSplit(handleConvertDataByDays(14));
        break;
      case "4":
        setActive(event.target.id);
        setResultAfterSplit(handleConvertDataByDays(30));
        break;
      default:
        break;
    }
  };

  const handleClickOption = (event) => {
    switch (event.target.value) {
      case "Total":
        setDefaulData(data);
        setActiveOption(event.target.value);
        setOptionChart(false);
        break;
      case "Active":
        setActiveOption(event.target.value);
        setDefaulData(dataActive);
        break;
      case "New":
        setActiveOption(event.target.value);
        setDefaulData(dataNew);
        break;
      default:
        break;
    }
  };

  const handleConvertDataByDays = (days) => {
    let copyArr = [...defaultData];
    return copyArr.splice(defaultData.length - days, days);
  };
  useEffect(() => {
    if (active !== "1" && activeOption !== "Total") {
      setOptionChart(true);
    } else {
      setOptionChart(false);
    }
  }, [active, activeOption]);

  return (
    <div className="wallet">
      <div className="top">
        <div className="title">{t("dashboard.Wallets")}</div>
        <div className="select">
          <select onChange={handleClickOption}>
            <option value="Total">{t("dashboard.Total")}</option>
            <option value="New">{t("dashboard.New")}</option>
            <option value="Active">{t("dashboard.Active")}</option>
          </select>
        </div>
      </div>
      <div className="number">
        {handleValue(defaultData[defaultData.length - 1].value)}{" "}
        {t("dashboard.Wallets")}
      </div>
      <div className="chart">
        {optionChart ? (
          <Barchart data={resultAfterSplit} />
        ) : (
          <LineChart
            data={active === "1" ? defaultData : resultAfterSplit}
            activeOption={activeOption}
          />
        )}
      </div>
      <div className="buttonGroup">
        {groupButton.map((res) => (
          <button
            key={res.id}
            id={res.id}
            className={active === res.id ? "active" : undefined}
            onClick={handleClick}
          >
            {res.name}
          </button>
        ))}
      </div>
    </div>
  );
};

export default Wallet;
